"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var utils_1 = require("@8base/utils");

var decimal_js_1 = require("decimal.js");

var validator_constants_1 = require("./validator.constants");

var INT_MAX_VALUE = Math.pow(2, 31) - 1;
var INT_MIN_VALUE = -Math.pow(2, 31);
var FLOAT_MAX_VALUE = Number.MAX_VALUE;
var FLOAT_MIN_VALUE = -Number.MAX_VALUE;
var getFieldTypeAttributes = R.prop('fieldTypeAttributes');
var getMinValueFromAttributes = R.pipe(getFieldTypeAttributes, R.prop('minValue'));
var getMaxValueFromAttributes = R.pipe(getFieldTypeAttributes, R.prop('maxValue'));
var getMaxPrecisionFromAttributes = R.pipe(getFieldTypeAttributes, R.prop('precision'));
var isBigIntFromAttributes = R.pipe(getFieldTypeAttributes, R.prop('isBigInt'));
var getMaxFieldSizeFromAttributes = R.pipe(getFieldTypeAttributes, R.prop('fieldSize'));
var getFormatFromAttributes = R.pipe(getFieldTypeAttributes, R.prop('format'));

var getMinValue = function getMinValue(field) {
  var minValue = getMinValueFromAttributes(field);
  var precision = getMaxPrecisionFromAttributes(field);

  if (typeof minValue === 'number') {
    return minValue;
  } else if (typeof precision === 'number' && precision !== 0) {
    return FLOAT_MIN_VALUE;
  }

  return INT_MIN_VALUE;
};

var getMaxValue = function getMaxValue(field) {
  var maxValue = getMaxValueFromAttributes(field);
  var precision = getMaxPrecisionFromAttributes(field);

  if (typeof maxValue === 'number') {
    return maxValue;
  } else if (typeof precision === 'number' && precision !== 0) {
    return FLOAT_MAX_VALUE;
  }

  return INT_MAX_VALUE;
};

var isEmpty = R.either(R.isNil, R.isEmpty);
var checkRequired = R.ifElse(R.complement(isEmpty), R.always(undefined), R.always(validator_constants_1.VALIDATION_ERROR.IS_REQUIRED()));
var checkIsNumber = R.ifElse(R.pipe(R.cond([[R.isNil, R.always(0)], [R.T, Number]]), R.complement(Number.isNaN)), R.always(undefined), R.always(validator_constants_1.VALIDATION_ERROR.NOT_A_NUMBER()));

var checkIsJson = function checkIsJson(value) {
  if (typeof value === 'string' && value.length > 0) {
    try {
      JSON.parse(value);
      return undefined;
    } catch (e) {
      return validator_constants_1.VALIDATION_ERROR.NOT_A_JSON(e.message);
    }
  }
}; // TODO: replace ternary operator by R.ifElse
// when https://github.com/flowtype/flow-typed/issues/2411
// will be resolved.


var checkMaxPrecision = function checkMaxPrecision(maxPrecision) {
  return function (value) {
    if (isEmpty(value)) {
      return undefined;
    }

    decimal_js_1.Decimal.set({
      defaults: true
    });
    var decimalValue = new decimal_js_1.Decimal(value);
    var precision = decimalValue.decimalPlaces();
    return precision <= maxPrecision ? undefined : validator_constants_1.VALIDATION_ERROR.MAX_PRECISION(maxPrecision);
  };
};

var checkMinValue = function checkMinValue(minValue) {
  return R.ifElse(R.cond([[isEmpty, R.T], [R.T, R.pipe(Number, R.lte(minValue))]]), R.always(undefined), R.always(validator_constants_1.VALIDATION_ERROR.MIN_VALUE(minValue)));
};

var checkMaxValue = function checkMaxValue(maxValue) {
  return R.ifElse(R.cond([[isEmpty, R.T], [R.T, R.pipe(Number, R.gte(maxValue))]]), R.always(undefined), R.always(validator_constants_1.VALIDATION_ERROR.MAX_VALUE(maxValue)));
};

var checkMaxFieldSize = function checkMaxFieldSize(maxFieldSize) {
  return R.ifElse(R.pipe(R.propOr(0, 'length'), R.gte(maxFieldSize)), R.always(undefined), R.always(validator_constants_1.VALIDATION_ERROR.MAX_FIELD_SIZE(maxFieldSize)));
}; // TODO: replace ternary operator by R.ifElse
// when https://github.com/flowtype/flow-typed/issues/2411
// will be resolved.


var checkFormat = function checkFormat(format) {
  return function (value) {
    if (isEmpty(value)) {
      return undefined;
    }

    return R.test(validator_constants_1.FORMAT_PATTERN[format], value || '') ? undefined : validator_constants_1.VALIDATION_ERROR[format]();
  };
};

var getCommonValidators = function getCommonValidators(field) {
  var validators = [];

  if (field.isRequired) {
    validators.push(checkRequired);
  }

  return validators;
};

var getNumberFieldValidators = function getNumberFieldValidators(field) {
  var validators = [checkIsNumber];
  var maxPrecision = getMaxPrecisionFromAttributes(field);
  var minValue = getMinValue(field);
  var maxValue = getMaxValue(field);
  var isBigInt = isBigIntFromAttributes(field);

  if (maxPrecision || maxPrecision === 0) {
    validators.push(checkMaxPrecision(maxPrecision));
  }

  if (minValue && !isBigInt) {
    validators.push(checkMinValue(minValue));
  }

  if (maxValue && !isBigInt) {
    validators.push(checkMaxValue(maxValue));
  }

  return validators;
};

var getTextFieldValidators = function getTextFieldValidators(field) {
  var validators = [];
  var maxFieldSize = getMaxFieldSizeFromAttributes(field);
  var format = getFormatFromAttributes(field);

  if (maxFieldSize) {
    validators.push(checkMaxFieldSize(maxFieldSize));
  }

  if (format && validator_constants_1.FORMAT_PATTERN[format]) {
    validators.push(checkFormat(format));
  }

  return validators;
};

var getDateFieldValidators = function getDateFieldValidators(field) {
  var validators = [];
  var format = getFormatFromAttributes(field);

  if (format && validator_constants_1.FORMAT_PATTERN[format]) {
    validators.push(checkFormat(format));
  }

  return validators;
};

var getSwitchFieldValidators = function getSwitchFieldValidators() {
  return [];
};

var getFileFieldValidators = function getFileFieldValidators() {
  return [];
};

var getRelationFieldValidators = function getRelationFieldValidators() {
  return [];
};

var getSmartFieldValidators = function getSmartFieldValidators() {
  return [];
};

var getJSONFieldValidators = function getJSONFieldValidators() {
  return [checkIsJson];
};

var processValidators = function processValidators(validators) {
  return R.converge(function () {
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    return R.find(R.is(String))(values);
  }, validators);
};
/**
 * ValidatorFacade creates validaton function based on field metadata
 * @param field - Field metadata
 * @returns - Validation function
 */


exports.validatorFacade = R.pipe(R.converge(R.concat, [getCommonValidators, R.cond([[R.propEq('fieldType', utils_1.FIELD_TYPE.NUMBER), getNumberFieldValidators], [R.propEq('fieldType', utils_1.FIELD_TYPE.TEXT), getTextFieldValidators], [R.propEq('fieldType', utils_1.FIELD_TYPE.DATE), getDateFieldValidators], [R.propEq('fieldType', utils_1.FIELD_TYPE.SWITCH), getSwitchFieldValidators], [R.propEq('fieldType', utils_1.FIELD_TYPE.FILE), getFileFieldValidators], [R.propEq('fieldType', utils_1.FIELD_TYPE.RELATION), getRelationFieldValidators], [R.propEq('fieldType', utils_1.FIELD_TYPE.SMART), getSmartFieldValidators], [R.propEq('fieldType', utils_1.FIELD_TYPE.JSON), getJSONFieldValidators], [R.propEq('fieldType', utils_1.FIELD_TYPE.GEO), function () {
  return [function () {
    return undefined;
  }];
}], [R.T, function (field) {
  throw new utils_1.SDKError(utils_1.ERROR_CODES.UNSUPPORTED_FIELD_TYPE, utils_1.PACKAGES.VALIDATE, "Validator doesn't support field type ".concat(field.fieldType));
}]])]), processValidators);